import { useQuery } from '@tanstack/react-query'

import { getRewardPointBalance } from '@src/api'
import { DefaultApiGetRewardPointBalanceRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchRewardPointBalance = (
  params: DefaultApiGetRewardPointBalanceRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getRewardPointBalance(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_REWARD_POINT_BALANCE],
  })
}
